export type AccountFormState = {
  success: boolean
  // errors
  apiError?: string
  errors: {
    [key: string]: string
  }
  // form values
  first_name?: string
  last_name?: string
  job_title?: string
  phone?: string
  city?: string
  country?: string
  email?: string
  confirmEmail?: string
}

export const initialAccountFormState: AccountFormState = {
  success: false,
  errors: {},
}

export const createEmptyAccountFormState = (
  formData?: Record<string, string>,
): AccountFormState => {
  return {
    ...initialAccountFormState,
    ...formData,
  }
}
